export const PERMISSIONS = {
  // Menus
  MENU_DASHBOARD:      'MENU_DASHBOARD',
  MENU_USERS:          'MENU_USERS',
  MENU_STORES:         'MENU_STORES',
  MENU_ITEMS:          'MENU_ITEMS',
  STOCKTAKE_VIEW:      'STOCKTAKE_VIEW',
  STOCK_TRANSFER_VIEW: 'STOCK_TRANSFER_VIEW',
  MENU_ACCOUNTING:     'MENU_ACCOUNTING',
  // Actions
  ACTION_CREATE_USER:            'ACTION_CREATE_USER',
  ACTION_MANAGE_STORE:           'ACTION_MANAGE_STORE',
  ACTION_CREATE_JOURNAL_ENTRY:   'ACTION_CREATE_JOURNAL_ENTRY',
  // Dashboard views — which dashboard board(s) a user may see. Default follows role
  // (owner=InstitutionAdmin, manager=InstitutionManager, accountant=Accountant); an admin
  // can override per-user here without creating a dedicated role.
  DASHBOARD_VIEW_OWNER:          'DASHBOARD_VIEW_OWNER',
  DASHBOARD_VIEW_MANAGER:        'DASHBOARD_VIEW_MANAGER',
  DASHBOARD_VIEW_ACCOUNTANT:     'DASHBOARD_VIEW_ACCOUNTANT',
} as const;

export type PermissionKey = typeof PERMISSIONS[keyof typeof PERMISSIONS];

type CatalogSubItem = { key: string; label: string };
type CatalogItem = { key: string; label: string; subItems?: CatalogSubItem[] };
type CatalogGroup = { group: string; items: CatalogItem[] };

export const PERMISSION_CATALOG: CatalogGroup[] = [
  {
    group: 'Menus',
    items: [
      { key: PERMISSIONS.MENU_DASHBOARD,    label: 'Dashboard' },
      { key: PERMISSIONS.MENU_USERS,        label: 'Users' },
      { key: PERMISSIONS.MENU_STORES,       label: 'Stores' },
      { key: PERMISSIONS.MENU_ITEMS,        label: 'Items' },
      { key: PERMISSIONS.STOCKTAKE_VIEW,    label: 'Stocktakes' },
      { key: PERMISSIONS.STOCK_TRANSFER_VIEW, label: 'Stock Transfers' },
      { key: PERMISSIONS.MENU_ACCOUNTING,   label: 'Accounting' },
    ],
  },
  {
    group: 'Actions',
    items: [
      { key: PERMISSIONS.ACTION_CREATE_USER,          label: 'Create Users' },
      { key: PERMISSIONS.ACTION_MANAGE_STORE,         label: 'Manage Stores' },
      { key: PERMISSIONS.ACTION_CREATE_JOURNAL_ENTRY, label: 'Create Journal Entries' },
    ],
  },
  {
    group: 'Dashboard views',
    items: [
      { key: PERMISSIONS.DASHBOARD_VIEW_OWNER,      label: 'Business-owner dashboard' },
      { key: PERMISSIONS.DASHBOARD_VIEW_MANAGER,    label: 'Manager dashboard' },
      { key: PERMISSIONS.DASHBOARD_VIEW_ACCOUNTANT, label: 'Accountant dashboard' },
    ],
  },
];
